import { render, staticRenderFns } from "./EditLeaderBoardTeam.vue?vue&type=template&id=3151f72a&scoped=true"
import script from "./EditLeaderBoardTeam.vue?vue&type=script&lang=js"
export * from "./EditLeaderBoardTeam.vue?vue&type=script&lang=js"
import style0 from "./EditLeaderBoardTeam.vue?vue&type=style&index=0&id=3151f72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151f72a",
  null
  
)

export default component.exports